module.exports = __webpack_public_path__ + "static/media/change-direction.68ea0882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/change-direction.svg
// module id = 233
// module chunks = 0